import { render, staticRenderFns } from "./appAssetFormatListItem.vue?vue&type=template&id=3a316438&scoped=true"
import script from "./appAssetFormatListItem.vue?vue&type=script&lang=js"
export * from "./appAssetFormatListItem.vue?vue&type=script&lang=js"
import style0 from "./appAssetFormatListItem.vue?vue&type=style&index=0&id=3a316438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a316438",
  null
  
)

export default component.exports